export default __webpack_public_path__ + "static/media/js.fd46ca41.svg";